import i18n from '../../../../i18n';
import { formatRange } from '../../lib/contextSummary';
import type { RequestViewContext } from '../../lib/viewContext';

/**
 * Suggested first questions in the words of the context a new chat starts
 * from (filtering audit 3.2: the home said "last 30 days" while the period
 * was 4 weeks). They name the period's dates and, when there is one, the
 * comparison's, so a starter never asks for dates outside the context it
 * will be answered in. Null when the screen uses no period.
 */
export function contextStarters(vc: RequestViewContext | null | undefined, variant: 'home' | 'panel'): string[] | null {
  if (!vc?.uses?.period || !vc.period?.start || !vc.period?.end) return null;
  const range = formatRange(vc.period.start, vc.period.end);
  const compare =
    vc.uses.comparison && vc.comparison?.kind !== 'none' && vc.comparison?.start && vc.comparison?.end
      ? formatRange(vc.comparison.start, vc.comparison.end)
      : null;
  const t = (key: string) => i18n.t(`assistant:conversation.starters.${key}`, { range, compare }) as string;
  if (variant === 'home') {
    return [t('guests'), t('cancelMix'), t('channel'), compare ? t('compare') : t('weekday')];
  }
  return [t('panelGuests'), t('panelSources'), t('panelWeekly'), compare ? t('panelNoShowsCompare') : t('panelNoShows')];
}
